import loadable from '@loadable/component';
import { Loader } from '../Loader';

const Authentication = loadable(() => import('./Authentication'), { fallback: <Loader /> });

export { Authentication };
